import TypeDto from 'app/admin/tesztlapok/dto/TypeDto';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import { Controller, useFormContext, useWatch } from 'react-hook-form';

function FeltoltesTesztlapFirstStep(props) {
	const { examList } = props;
	const methods = useFormContext();
	const packageName = useWatch({
		name: 'packageName',
		control: methods.control
	});

	return (
		<>
			<div className="mb-16">
				A lentebbi adatok megadása után, majd a feltöltés gombra kattintva a felugró ablakban válassza ki az összes egy csomaghoz tartozó feltölteni kívánt fájlt (Csak jpg kiterjesztésű fájlokat töltsön fel!).
			</div>
			<div className="flex flex-row rounded-8 border px-16 pt-10 pb-4 mb-16">
				<Controller
					control={methods.control}
					name="examId"
					render={({ field, fieldState }) => (
						<EditFormSelectField
							field={field}
							fieldState={fieldState}
							config={{ topic: 'feltoltesTesztlapForm' }}
							fieldConfig={{
								key: 'examId',
								text: 'Vizsganév',
								required: true,
								items: examList,
								className: 'mr-8'
							}}
						/>
					)}
				/>
				<Controller
					control={methods.control}
					name="paperType"
					render={({ field, fieldState }) => (
						<EditFormSelectField
							field={field}
							fieldState={fieldState}
							config={{ topic: 'feltoltesTesztlapForm' }}
							fieldConfig={{
								key: 'paperType',
								text: 'Laptípus',
								required: true,
								type: 'enum',
								className: 'mx-8',
								items: Object.keys(TypeDto).map(key => {
									return { label: TypeDto[key], value: key };
								})
							}}
						/>
					)}
				/>
				{packageName && <div className="mx-8 mt-24">{packageName}</div>}
				<Controller
					control={methods.control}
					name="description"
					render={({ field, fieldState }) => (
						<EditFormTextField
							field={field}
							fieldState={fieldState}
							config={{ topic: 'feltoltesTesztlapForm' }}
							fieldConfig={{
								key: 'description',
								text: 'Csomag',
								required: true,
								mask: {
									mask: /^[a-zA-Z0-9_]*$/
								}
							}}
						/>
					)}
				/>
			</div>
		</>
	);
}

export default FeltoltesTesztlapFirstStep;
